import { Fragment } from "react";
import { Link } from "react-router-dom";

export const Learning = () => (
  <Fragment>
    <li>
      <Link to="/CDE-Intro">Cloudera Data Engineering</Link>
    </li>
    <li>
      <Link to="/hive">Cloudera Data Analyst</Link>
    </li>
    <li>
      <Link to="/CAI-Intro">Cloudera AI</Link>
    </li>
  </Fragment>
);
export const Solution = () => (
  <Fragment>
    <li>
      <Link to="/AI-Accounting-Finance">AI Accounting & Finance</Link>
    </li>
    <li>
      <Link to="/AI-Audit-Compliance">AI Audit & Compliance</Link>
    </li>
    <li>
      <Link to="/AI-Human-Resources">AI Human Resources</Link>
    </li>
    <li>
      <Link to="/AI-Operations">AI Operations</Link>
    </li>
  </Fragment>
);
export const Services = () => (
  <Fragment>
    {/* <li><Link to="/services">Services</Link></li> */}
    <li>
      <Link to="/RPA-AI">AI & RPA</Link>
    </li>
    <li>
      <Link to="/Whatsapp-estore">WhatsApp Services</Link>
    </li>
    <li>
      <Link to="/Web-Development">Web Development</Link>
    </li>
    <li>
      <Link to="/digital-consultancy">Digital Consulting</Link>
    </li>
    <li>
      <Link to="/Data-Engineering">Data Engineering</Link>
    </li>
    <li>
      <Link to="/Data-Science">AI/ML</Link>
    </li>
  </Fragment>
);
// export const Page = () => (
//     <Fragment>
//         <li><Link to="/projects">Projects</Link></li>
//         <li><Link to="/projects-details">Projects Details</Link></li>
//         <li><Link to="/pricing">Pricing</Link></li>
//         <li><Link to="/team">Team</Link></li>
//         <li><Link to="/testimonial">Testimonial</Link></li>
//         <li><Link to="/error">404 Page</Link></li>
//     </Fragment>
// );
export const News = () => (
  <Fragment>
    <li>
      <Link to="/Rpa-training">AI & RPA </Link>
    </li>
    <li>
      <Link to="/python">Python & SQL</Link>
    </li>
    <li>
      <Link to="/cloud">Data Science With Python</Link>
    </li>
    <li>
      <Link to="/Data-engineering-course">Cloudera Data Engineering</Link>
    </li>
        <li>
      <Link to="/Data-analyst">Cloudera Data  Analyst</Link>
    </li>
    <li>
      <Link to="/AI">Cloudera AI</Link>
    </li>
    <li>
      <Link to="/Machine-Learning">Cloudera ML</Link>
    </li>



    {/* <li><Link to="/blog-details">Whatsapp & openai</Link></li>
        <li><Link to="/rpa-blog">RPA</Link></li>
        <li><Link to="/react-blog">Reactjs</Link></li>
        <li><Link to="/Big-Data">Big Data</Link></li>
        <li><Link to="/Big-Data-pipeline">Big Data pipeline</Link></li> */}
  </Fragment>
);
